import 'idempotent-babel-polyfill';
import 'jquery-ujs';

// polyfills
import '../polyfills';

// presenter and methods
import { executeScriptsFromLiquidTags } from '../liquidTags';
import { init } from './init';

// init form stuff only when form container is rendered
const formInterval = setInterval(() => {
  if (document.querySelector('.qpb-form')) {
    clearInterval(formInterval);
    init();
    executeScriptsFromLiquidTags();
  }
}, 100);

// clear the interval after 4 seconds anyways
setTimeout(() => {
  clearInterval(formInterval);
}, 4000);



// WEBPACK FOOTER //
// ./webflow_forms/main.js